const fireflyData = {
  application: {
    name: 'MVS-VIS',
  },
  view: {
    globalName: 'Manufacturing Visibilty UI',
    type: {
      button: 'Button',
      tab: 'Tab',
      error: 'Error',
      searchBar: 'searchBar',
      textBox: 'TextBox',
      select: 'Select',
      card: 'Card',
      page: 'Page',
      dialog: 'Dialog',
      filter: 'Filter',
      row: 'Row',
    },
  },
  event: {
    type: {
      login: 'login',
      click: 'click',
      download: 'download',
      select: 'select',
      pageLoad: 'pageload',
      response: 'response',
      edit: 'edit',
      search: 'search',
      submit: 'submit',
      delete: 'delete',
    },
  },
}

export default fireflyData
